import React from 'react';
import styled from 'styled-components';
import { KitFlexColCentered } from '../KitFlexbox';
import { spacing } from '../../common/theme/constants';
import { TranslateFunc } from '../../common/types';
import cpLogo from '../../images/cp_logo.png';

// cpLogo original size = 172x32
const SmallChargePointLogo = styled.img`
  width: 112px;
  height: 21px;
`;

const PoweredByContainer = styled(KitFlexColCentered)`
  padding-left: ${spacing.absolute.l}px;
  padding-right: ${spacing.absolute.l}px;
`;

interface PoweredByProps {
  t: TranslateFunc;
}

const PoweredBy: React.FC<PoweredByProps> = (props: PoweredByProps) => {
  const { t } = props;
  return (
    <PoweredByContainer>
      <SmallChargePointLogo src={cpLogo} alt={t('kit:nav_bar.powered_by_chargepoint')} />
    </PoweredByContainer>
  );
};

export default PoweredBy;
